var map = {
	"./album-1.png": 40520,
	"./album-10.png": 63866,
	"./album-11.png": 27971,
	"./album-12.png": 91112,
	"./album-13.png": 7358,
	"./album-14.png": 1886,
	"./album-15.png": 70727,
	"./album-16.png": 51724,
	"./album-17.png": 3989,
	"./album-18.png": 16786,
	"./album-19.png": 70344,
	"./album-2.png": 2499,
	"./album-20.png": 57355,
	"./album-21.png": 36226,
	"./album-22.png": 92313,
	"./album-23.png": 86064,
	"./album-24.png": 81935,
	"./album-3.png": 12666,
	"./album-4.png": 81077,
	"./album-5.png": 69452,
	"./album-6.png": 20135,
	"./album-7.png": 44350,
	"./album-8.png": 105,
	"./album-9.png": 75904
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24329;